<template>
  <div class="p-4 bg-white border border-gray-300 rounded h-full">
    <div class="flex flex-row">
      <zt-icon name="calendar-birthday" class="w-6 h-6 text-gray-500 icon-birthday pt-1" />
      <h1 class="text-xl font-medium ml-2">{{ $t('message.dashboard.pendingTasks.title') }}</h1>
    </div>

    <div class="mt-3 flex flex-col overflow-pending" v-if="pendingTasks.length > 0">
      <div v-for="(task, index) in pendingTasks" :key="index" class="flex items-center my-2 ">
        <div class="border border-gray-300 rounded p-2 flex items-center w-full  flex-col">
          <div class="w-full text-xs flex justify-between items-center" small><span
              class="chipTaskType flex uppercase">{{ $t(`message.dashboard.pendingTasks.${task.type}`) }}</span>
            <div class="flex justify-end task-icon-container">
              <div class="task-icon cursor-pointer" data-vs-button="task-details" @click="openSingle('details', task)">
                <zt-icon name="eye" class="text-zt-dark-300 py-1 text-lg" />
              </div>
              <div v-if="task.type === 'LICENSES'" class="task-icon" data-vs-button="task-reject"
                @click="openSingle('reject', task)">
                <zt-icon name="times" class="text-zt-dark-300 pt-2 text-md" />
              </div>
              <div v-if="task.type === 'LICENSES'" class="task-icon cursor-pointer" data-vs-button="task-approve"
                @click="openSingle('approve', task)">
                <zt-icon name="check" class="text-zt-dark-300 pt-2 text-md" />
              </div>
            </div>
          </div>
          <div class="w-full flex align-center">

            <zt-avatar v-if="task.avatar" :src="task.avatar" class=".scale-75" />
            <zt-avatar v-else :text="task.initials" :color="task.color" class=".scale-75" />
            <p class="ml-2 text-zt-dark-500 text-zt-md">{{ task.employee }} </p>
          </div>
          <div class="w-full">
            <span v-if="task.type === 'LICENSES'" class="text-zt-dark-300 text-zt-md"><zt-icon name="calendar-day" />
              {{ task.requestDays }} {{ task.requestDays === '1' ? 'día' : 'días' }} {{ task.dateIn }} > {{
                task.dateOut }}</span>
            <span v-if="task.sector === 'CABA'" class="text-zt-dark-300 text-zt-md"><zt-icon name="file" />
              [] Documento</span>
            <span v-if="task.sector === 'COMERCIAL'" class="text-zt-dark-300 text-zt-md"> <zt-icon name="sync" /> []
              workflow</span>
          </div>
        </div>
      </div>
      <zt-modal :active="pendingTaskPopUp" @close='pendingTaskPopUp = false'
        :max-width="(modalIsDetail) ? '800px' : '40rem'" :title='$t("message.dashboard.absences")' class="scroll">
        <template slot="modal-header">
          <div class="p-4 text-zt-lg flex">
            <div v-if="state.showViewer" @click="resetShowViewer()" class="cursor-pointer mr-4">
              <zt-icon name="angle-left" />
              <span>{{ $t("message.loginComponent.forgetPasswordInvalid.goBack") }}</span>
            </div>
            <span class="font-bold">{{ titleModal }}</span>
          </div>
        </template>
        <hr class="w-full" />
        <component :is="componentBodyModal" :request="request" @close="pendingTaskPopUp = false" :state="state"
          @change-modal="openSingleFromDetail" @clean-massive-array="deleteTaskById" />
        <template slot='modal-footer' v-if="modalIsDetail">
          <div class='zt-modal-footer flex justify-center lg:justify-end items-center p-4'>
            <zt-button class='mr-1' outlined @click='pendingTaskPopUp = false'>
              {{ $t("message.HeaderComponent.filters.close") }}
            </zt-button>
          </div>
        </template>
      </zt-modal>
    </div>
    <div v-else class="flex bg-white rounded py-6 ">
      <div class="flex justify-center pl-2">
        <DesertSVG />
      </div>

      <div class="text-center md:text-left mt-4 ml-2 mr-8">
        <h1 class="text-2xl font-semibold text-gray-700">
          {{ $t('message.dashboard.notFound.title') }}
        </h1>
        <h2 class=" text-gray-600 font-medium py-2">
          {{ $t('message.dashboard.pendingTasks.notFound') }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import Manager from "@/apiClient/Manager"
import DesertSVG from '@/components/commons/Illustrations/graphicSVG/DesertSVG'
import Details from '@/modules/Licenses/components/pending/Details.vue'
import Approve from '@/modules/Licenses/components/pending/Approve'
import Reject from '@/modules/Licenses/components/pending/Reject'

export default {
  inject: {
    mutations: { default: null },
    state: { default: () => ({}) }
  },
  components: {
    DesertSVG, Details, Approve, Reject
  },
  data() {
    return {
      manager: Manager,
      pendingTasks: [],
      pendingTaskPopUp: false,
      activeTaskId: "",
      request: {},
      componentBodyModal: '',
      titleModal: '',
      modalIsDetail: false,
    }
  },
  async created() {
    this.manager = new Manager();
    await this.getPendingTasks()
  },

  methods: {
    async getPendingTasks() {
      try {
        this.pendingTasks = (await this.manager.getPendingTasks()).data.data;
      } catch (error) {
        this.pendingTasks = []
      }
    },
    deleteTaskById() {
      const id = this.activeTaskId
      const index = this.pendingTasks.findIndex((item) => item.id === id);
      this.pendingTasks.splice(index, 1);
    },
    openSingleFromDetail(value) {
      this.openSingle(value.action, value.request, true)
    },
    resetShowViewer() {
      this.mutations.setShowViewer(false)
    },
    async openSingle(to, item, keepRequest = false) {
      this.resetShowViewer()
      this.modalIsDetail = false
      if (!keepRequest) {
        const response = await this.manager.getTaskDetails(item.id, item.type)
        this.activeTaskId = item.id
        this.request = response.data.data
      }
      switch (to) {
        case 'approve':
          this.componentBodyModal = Approve
          this.request = [this.request]
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.approveTitle')
          this.pendingTaskPopUp = !this.pendingTaskPopUp
          break
        case 'reject':
          this.componentBodyModal = Reject
          this.request = [this.request]
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.rejectTitle')
          this.pendingTaskPopUp = !this.pendingTaskPopUp
          break
        case 'details':
          this.modalIsDetail = true
          this.componentBodyModal = Details
          this.titleModal = `${this.$t('message.LincensesApprovalPendingComponent.header.title')} - ${item.employee}`
          this.pendingTaskPopUp = !this.pendingTaskPopUp
          break
        default:
          break
      }
    },
  }
}
</script>

<style scoped>
.overflow-pending {
  overflow-y: auto;
  max-height: 400px;
}

.chipTaskType {
  padding: 3px 10px !important;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 4px;
  max-height: 18px;
  max-width: 81px;
  text-align: center;
  border: 1px solid var(--branding-lightThemeBg, var(--branding-primary, var(--v-primary-base)));
  ;
  color: var(--branding-lightThemeBg, var(--branding-textColor, var(--v-primary-base)));
}

.task-icon-container {
  display: flex;
  justify-content: flex-end;
}

.task-icon {
  border: 1px solid;
  margin: 0 5px;
  text-align: center;
  max-height: 30px;
  width: 30px;
  border: 1px solid rgba(128, 128, 128, 0.678);
  border-radius: 5px;
}

.scroll {
  max-height: 800px;
}

::v-deep div.scroll>div.flex.h-full>div {
  max-height: auto;
  overflow-y: auto !important;
  max-height: calc(100vh - 200px)
}
</style>